import { render, staticRenderFns } from "./elevatorAlarm.vue?vue&type=template&id=e0a1c204&"
import script from "./elevatorAlarm.vue?vue&type=script&lang=js&"
export * from "./elevatorAlarm.vue?vue&type=script&lang=js&"
import style0 from "./elevatorAlarm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports